var _a;
import { DA_COMM_EMOTE, DA_OFF_EMOTE } from './types';
import { OfficialHtml, CommunityHtml } from './viewer/HtmlViewer';
import { OfficialEmoteViewer, CommunityEmoteViewer, } from './viewer/ReactViewer';
export var typeMapper = function () {
    var _a;
    return (_a = {},
        _a[DA_OFF_EMOTE] = {
            component: OfficialEmoteViewer,
            elementType: 'inline',
        },
        _a[DA_COMM_EMOTE] = {
            component: CommunityEmoteViewer,
            elementType: 'inline',
        },
        _a);
};
export var htmlTypeMapper = (_a = {},
    _a[DA_OFF_EMOTE] = OfficialHtml,
    _a[DA_COMM_EMOTE] = CommunityHtml,
    _a);
//# sourceMappingURL=typeMapper.js.map